import { EMPTY_OBJECT } from '../../../constants/common'
import { QA_NAME_SAVE_BTN } from '../../../constants/qa'
import { FormModal } from '../../Form'

function EntityEditFormModal({
  containerProps,
  formBodyProps: {
    submitQaName = QA_NAME_SAVE_BTN,
    withNotifications = true,
    ...formBodyProps
  } = EMPTY_OBJECT,
  qaName,
  onSubmit,
  ...restProps
}) {
  function handleSubmit({ setErrors, setSubmitting, value, values }) {
    onSubmit({
      payload: value,
      setErrors,
      setSubmitting,
      values,
    })
  }

  return (
    <FormModal
      {...restProps}
      containerProps={{
        ...containerProps,
        qaName,
      }}
      formBodyProps={{
        ...formBodyProps,
        submitQaName,
        withNotifications,
      }}
      onSubmit={handleSubmit}
    />
  )
}

export default EntityEditFormModal
